<!-- <div nz-row> -->
    <!-- <div nz-col nzSpan="24"> -->
        <!-- <nz-layout class="app-layout" [ngClass]="{ 'ant-layout-custom' : true }"> -->
            <!-- <nz-header class="sticky-top text-center" style="background:none;" > -->
                <div nz-row>
                    <div nz-col nzSpan="24" style="text-align:center;">
                        <img src="./../assets/Images/theme_logo/tyremart.png" class="header-logo" />
                        <!-- <img src="./../assets/Images/stockfinder-black.png" class="header-logo" /> -->
                    </div>
                </div>
                <!-- </div> -->
                <!-- <div nz-col nzXs="0" nzSm="0" nzMd="0" nzLg="8" nzXL="8" style="text-align:center;">
                    <img src="./../assets/Images/theme_logo/{{themeService.themeLogo()}}" class="header-logo" />
                </div> -->
            <!-- </nz-header> -->
            <nz-content>
                <!-- <div nz-row nzAlign="middle" nzJustify="center">
                    <div nz-col nzSpan="8" style="text-align:center;">

                    </div>
                    <div nz-col nzSpan="8">
                        <h2 class="text-center">CALL CENTRE FLEET AUTHORISATION </h2>
                    </div>
                    <div nz-col nzSpan="8">
                    </div>
                </div> -->
            <div nz-row [nzGutter]="24" class="inner-content">
                <div nz-col [nzSpan]="12" >
                    <form nz-form [formGroup]="sendAuthorizationForm">
                        <h3>Auth Status : 
                            <span *ngIf="authData.isAuthorised === null" style="color: orange;">{{authData.authStatus}}</span>
                            <span *ngIf="authData.isAuthorised !== null"[style]="authData.isAuthorised ? 'color: green ' : 'color: red'">{{authData.authStatus}}</span>
                        </h3>
                        <h4>Merchant Number: {{authData.merchantNumber}}</h4>                       
                        <h4 *ngIf="authData.isAuthorised === true && authData.isLocked">Authorisation Number: {{authData.authNumber}}</h4>                       
                        <h6 *ngIf="authData.isAuthorised === null">Time since email: {{timeSinceEmailed}} ago</h6>
                        <h6 *ngIf="authData.isAuthorised !== null">Timeframe for response: {{timeSinceEmailed}}</h6>
                        <nz-divider></nz-divider>
                        <nz-result *ngIf="authData.isAuthorised === true && authData.isLocked" 
                            nzStatus="success"
                            nzTitle="Authorisation has been approved">
                        </nz-result>
                        <nz-result *ngIf="authData.isAuthorised === false && authData.isLocked"
                            nzStatus="error"
                            nzTitle="Authorisation has been rejected">
                        </nz-result>
                        <nz-form-item>
                            <nz-form-label nzRequired *ngIf="authData.isAuthorised !== null && !authData.isLocked"><h6>Authorise Quote</h6></nz-form-label>
                            <nz-form-control class="text-center">
                                <nz-result *ngIf="authData.isAuthorised === null && !authData.isLocked" nzStatus="info" nzTitle="Quote pending your authorisation">
                                    <div nz-result-extra>
                                        <nz-radio-group formControlName="isAuthorised" nzButtonStyle="solid" [nzSize]="'large'" (ngModelChange)="changeAuthStatus()">
                                            <label nz-radio-button [nzValue]="true">Approve</label>
                                            <label nz-radio-button [nzValue]="null">Pending</label>
                                            <label nz-radio-button [nzValue]="false">Decline</label>
                                        </nz-radio-group>
                                    </div>
                                </nz-result>
                                <div nz-result-extra *ngIf="authData.isAuthorised !== null && !authData.isLocked">
                                    <nz-radio-group formControlName="isAuthorised" nzButtonStyle="solid" [nzSize]="'large'" (ngModelChange)="changeAuthStatus()">
                                        <label nz-radio-button [nzValue]="true">Approve</label>
                                        <label nz-radio-button [nzValue]="null">Pending</label>
                                        <label nz-radio-button [nzValue]="false">Decline</label>
                                    </nz-radio-group>
                                </div>
                        </nz-form-control>
                        </nz-form-item>
                        <!-- <nz-result *ngIf="authData.isAuthorised === null" nzStatus="info" nzTitle="Authorisation awaiting your approval">
                            <div nz-result-extra>
                                <p>Click on the button to approve or decline the quote</p>
                            </div>
                        </nz-result> -->
                        <div *ngIf="authData.isAuthorised !== null && !authData.isLocked">
                            <nz-form-item *ngIf="authData.isAuthorised">
                                <nz-form-label [nzRequired]="authData.isAuthorised"><h6>Auth Number</h6></nz-form-label>
                                <nz-form-control>
                                    <nz-input-group >
                                        <input formControlName="authNumber" nz-input id="authNumber" placeholder="Enter auth number">
                                    </nz-input-group>
                                </nz-form-control>
                            </nz-form-item>
                            <nz-form-item  *ngIf="authData.isAuthorised">
                                <nz-form-label><h6>Attach Authorisation Letter</h6></nz-form-label>
                                <input nz-input  formControlName="authLetter" [type]="'file'" id=" auth letter" placeholder=" auth letter " name=" auth letter " (change)="onFileSelected($event)" accept="application/pdf,application/vnd.ms-excel">
                            </nz-form-item>
                            <nz-form-item>
                                <nz-form-control>
                                    <nz-input-group >
                                        <textarea nz-input formControlName="message" placeholder="Message" [nzAutosize]="{ minRows: 5, maxRows: 15 }"></textarea>
                                    </nz-input-group>
                                </nz-form-control>
                            </nz-form-item>
                        </div>
                    </form>
                    <div *ngIf="authData.isAuthorised !== null && !authData.isLocked">
                        <nz-input-group [nzAddOnAfter]="addOnAfterTemplate" nzSize="large" >
                            <input nz-input id="email" placeholder="Enter email addresses seperated by a comma" [(ngModel)]="emails" name="email">
                            <ng-template #addOnAfterTemplate>
                                <button nz-button (click)="addEmail()" [disabled]="isLocked">Add</button>
                            </ng-template>
                        </nz-input-group>
                        <address> An email will be sent with all required info to {{authData.emailAddresses}}</address> 
                        <div nz-row [nzJustify]="'space-around'">
                            <button nz-button nzType="primary" [disabled]="!sendAuthorizationForm.valid" (click)="sendAuth(authData.sfReference)">Send Authorization</button>
                        </div> 
                    </div>
                </div>
                <div nz-col [nzSpan]="12">
                    <nz-spin [nzSpinning]="isLoading">
                    <form nz-form >
                        <h4>ALL INFORMATION CAPTURED BY THE SALESMAN CAN BE FOUND BELOW</h4>
                        
                        <nz-list nzBordered  style="margin-block: 10px;">
                            <nz-list-item>
                                <b nz-typography>Download</b>
                                <nz-button-group>
                                    <button nz-button nzType="default" (click)="downloadQuote()" nzSize="large">
                                        <span nz-icon nzType="file-pdf" nzTheme="outline" ></span>Quote
                                    </button>
                                    <button nz-button *ngIf="authData.authLetterBase64 !== null" nzType="default" (click)="downloadAuthLetter()" nzSize="large">
                                        <span nz-icon nzType="file-pdf" nzTheme="outline" ></span>Authorisation Letter
                                    </button>
                                </nz-button-group>
                            </nz-list-item>
                        </nz-list>
                        <nz-list nzBordered  style="margin-block: 10px;">
                            <nz-list-item>
                                <b nz-typography>Fitment Centre Details</b>
                                {{ authData.fitmentCentreDetails }}
                            </nz-list-item>
                        </nz-list>
                        <nz-list nzBordered style="margin-block: 10px;">
                            <nz-list-item>
                                <b nz-typography>Salesman Details</b>
                                {{ authData.salesManDetails }}
                            </nz-list-item>
                        </nz-list>
                        <!-- <ng-container> -->
                            <nz-list nzBordered *ngFor="let field of authData.fields" style="margin-block: 10px;">
                                <nz-list-item>
                                    <b nz-typography>{{ field.fleetAuthFieldName }}</b>
                                    
                                    <!-- <a *ngIf="field.dataType===3 && field.fleetAuthFieldValueId" nz-row [nzJustify]="'space-around'" (click)="openFile(authData.quoteId, field.fleetAuthFieldValueId)" style="cursor: pointer; color: blue; text-decoration: underline;">
                                        View Image
                                    </a> -->
                                    <nz-list-item-extra>
                                        <span>{{ field.fleetAuthFieldValue }}</span>
                                        <a *ngIf="(field.dataType==3 || field.dataType==4) && field.fleetAuthFieldValueId !== null" (click)="openFile(authData.quoteId, field.fleetAuthFieldValueId)" style="cursor: pointer; margin-left: 10px; margin-top: 5px;" nz-tooltip="Click to view image" [nzTooltipPlacement]="'top'">
                                            <span nz-icon nzType="file-jpg" nzTheme="outline"> </span>
                                        </a>
                                    </nz-list-item-extra>
                                </nz-list-item>
                            </nz-list>
                        <nz-modal [(nzVisible)]="isImageViewerVisible" [nzTitle]="currentField?.fleetAuthFieldName" [nzFooter]="null" (nzOnCancel)="closeImageViewer()">
                            <div *nzModalContent>
                            <nz-spin [nzSpinning]="isLoading">
                                <div *ngIf="selectedImages && selectedImages.length > 0; else noImages" 
                                    style="display: flex; flex-wrap: wrap; gap: 20px; justify-content: space-evenly;">
                                
                                <div *ngFor="let image of selectedImages" 
                                    style="position: relative; flex: 0 0 auto;">
                                    <ng-container *ngIf="image.endsWith('.pdf') || image.startsWith('data:application/pdf'); else imageBlock">
                                    <embed 
                                        [src]="sanitizer.bypassSecurityTrustResourceUrl(image)" 
                                        type="application/pdf" 
                                        width="250px" 
                                        height="300px" />
                                    </ng-container>
                                    
                                    <ng-template #imageBlock>
                                    <img 
                                        [src]="sanitizer.bypassSecurityTrustResourceUrl(image)" 
                                        style="width: 250px; height: auto; max-height: 300px; object-fit: contain;"
                                        nz-tooltip="Click to open in new tab"
                                        (click)="openImageInNewTab(image)"
                                    />
                                    </ng-template>
                                </div>
                                </div>
                                
                                <ng-template #noImages>
                                <div style="text-align: center; padding: 40px; color: #999;">
                                    <p>No images to display</p>
                                </div>
                                </ng-template>
                            </nz-spin>
                            </div>
                        </nz-modal>
                                    <!-- </ng-container> -->     
                    </form>
                    </nz-spin>
                </div>
            </div>
        </nz-content>
    <!-- </nz-layout> -->
    <!-- </div> -->
<!-- </div> -->

  
  
